import React from 'react';
import ReactDOM from 'react-dom/client';
import './mobile.css';
import App from './App';
import { initSentry } from './utils/sentry';

initSentry();

// Capture a "?mailto=..." protocol-handler invocation as early as possible —
// before any auth redirect can drop the query string. The webmail Inbox
// reads this from sessionStorage once the user is connected and opens the
// compose dialog with the mailto fields pre-filled.
try {
  const params = new URLSearchParams(window.location.search);
  const raw = params.get('mailto') || params.get('compose');
  if (raw) {
    sessionStorage.setItem('emailLion_pendingMailto', raw);
    params.delete('mailto');
    params.delete('compose');
    const newSearch = params.toString();
    const newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  }
} catch (e) { /* ignore — non-fatal */ }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
